import { Rider_at_series } from './rider_at_series';
import { Credential_role_request } from './credential_role_request';

export class Competitor_credentials_request {
	
	id: string;
	user_id: string;
	competitor_person_id: string;
	horse_show_series_id: string;
	number: number;
	submitted: boolean;
	submitted_at: Date;
	created_at: Date;
	
	
	//Loaded for view
	competitor: Rider_at_series;
	employee_list: Credential_role_request[];
	
	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}